<template>
  <div>
    <v-container>
      <div class="mb-2">
        <v-tabs v-model="status" @change="onChangeStatusView" centered icons-and-text>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab href="#waiting" :key="'waiting'">
            <i class="fas fa-list-ul"></i>
            Waiting
          </v-tab>
          <v-tab href="#approve" :key="'approve'">
            <i class="far fa-check-circle"></i>
            Approved
          </v-tab>
          <v-tab href="#reject" :key="'reject'">
            <i class="far fa-times-circle"></i>
            Rejected
          </v-tab>
        </v-tabs>
      </div>
      <div class="mt-2">
        <div>
          <div>
            <div style="text-align: right">
              <span class="mr-3 mt-3">
                <v-checkbox
                  hide-details
                  style="display: inline-block; margin-top: 15px; position: relative; top: 9px"
                  v-model="input.need_production"
                  :label="'ถ่ายทำ'"
                ></v-checkbox
              ></span>
              <span style="display: inline-block">
                <multiselect
                  :placeholder="'ประเภทงาน'"
                  v-model="input.work_type"
                  :options="type"
                ></multiselect>
              </span>
              <span class="form-control" style="display: inline-block">
                <input v-model="input.search" placeholder="ค้นหาชื่อ" type="text" />
              </span>
            </div>
            <div>
              <v-layout>
                <v-flex xs7>
                  <Pagination
                    :key="status + '__' + update"
                    :limit="10"
                    :total="total"
                    @onChange="onChange($event, status)"
                  ></Pagination
                ></v-flex>
                <v-flex xs5>
                  <div class="text-xs-right">
                    <v-btn dense color="primary" @click="onSearch"
                      >ค้นหา<i class="ml-2 fas fa-search"></i
                    ></v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
        <v-data-table
          :no-data-text="pageloading ? '' : $vuetify.noDataText"
          :loading="pageloading"
          hide-actions
          disable-initial-sort
          :pagination.sync="sortBy"
          :headers="headers"
          :items="users"
          class="elevation-1 my-awesome-table"
        >
          <template slot="headerCell" slot-scope="props">
            <span v-if="props.header.text == 'รายละเอียด'">
              <span class="px-8" style="padding-left: 48px">&nbsp;</span>
              {{ props.header.text }}

              <span class="px-8" style="padding-left: 48px">&nbsp;</span>
            </span>

            <span v-else-if="props.header.text == 'อีเมล์'">
              <span class="px-8" style="padding-left: 25px">&nbsp;</span>
              {{ props.header.text }}

              <span class="px-8" style="padding-left: 25px">&nbsp;</span>
            </span>
            <span v-else>{{ props.header.text }} </span>
          </template>
          <template v-slot:items="props">
            <tr :style="props.item.oldcustomer ? `background-color: #dcf4ff` : ''" class="py-4">
              <td style="white-space: nowrap">
                <div>
                  <span v-if="status != 'approve'">
                    <v-btn
                      @click="approveClick(props.item.id, props.item.userid)"
                      color="green"
                      dark
                      icon
                      style="border-radius: 5px"
                      ><i class="fas fa-check"></i
                    ></v-btn>
                  </span>
                  <span v-if="status != 'reject'">
                    <v-btn
                      @click="rejectClick(props.item.id, props.item.userid)"
                      color="red"
                      dark
                      icon
                      style="border-radius: 5px"
                      ><i class="fas fa-times"></i
                    ></v-btn>
                  </span>
                </div>
              </td>
              <td class="pa-3">
                <div style="position: relative">
                  <v-avatar>
                    <v-img :src="props.item.profile_pic"></v-img>
                  </v-avatar>
                  <div v-if="!props.item.oldcustomer" class="newiconceeme">New</div>
                </div>
              </td>
              <td style="white-space: nowrap">
                <div style="position: relative">
                  {{ props.item.customer_name }}
                </div>
                <div>
                  <span
                    v-if="props.item.institute"
                    class="moochip"
                    style="background-color: rgb(61 38 185)"
                  >
                    {{ props.item.institute }}</span
                  >
                </div>
              </td>
              <td>
                <div>
                  {{ props.item.work_type ? props.item.work_type : '-' }}
                </div>
                <div>
                  <span v-if="props.item.need_qc" class="moochip" style="background-color: #3160b7">
                    QC
                  </span>
                  <span
                    v-if="props.item.need_production"
                    class="moochip"
                    style="background-color: #c78100; white-space: nowrap"
                    >{{ props.item.production_type }}</span
                  >
                </div>
              </td>
              <td>
                <div style="word-break: break-word">
                  {{ props.item.detail ? props.item.detail : '-' }}
                </div>
              </td>
              <td v-if="props.item.duedate">
                <div style="white-space: nowrap">
                  {{ moment.utc(props.item.duedate).format('DD/MM/YYYY') }}
                </div>
                <div>
                  {{ moment.utc(props.item.duedate).format(' HH:mm') }}
                </div>
              </td>
              <td v-if="props.item.timestamp">
                <div style="white-space: nowrap">
                  {{ moment.utc(props.item.timestamp).format('DD/MM/YYYY') }}
                </div>
                <div>
                  {{ moment.utc(props.item.timestamp).format(' HH:mm') }}
                </div>
              </td>
              <td v-else>-</td>
              <td>{{ props.item.location ? props.item.location : '-' }}</td>
              <td>{{ props.item.companyname ? props.item.companyname : '-' }}</td>
              <td>{{ props.item.phoneno }}</td>
              <td>{{ props.item.email }}</td>

              <td>
                <a
                  v-if="props.item.business_card"
                  @click="clickShowImage(props.item.business_card)"
                >
                  <v-img :src="props.item.business_card"></v-img>
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="showImage" width="700px">
          <v-card v-if="showImage">
            <div class="text-xs-right">
              <v-btn @click="showImage = ''" icon><v-icon>close</v-icon></v-btn>
            </div>
            <v-card-text>
              <div><v-img :src="currentImg"></v-img></div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          persistent
          v-model="approveModal"
          max-width="700px"
          transition="dialog-transition"
        >
          <v-card v-if="approveModal">
            <v-card-text>
              <intent-group v-model="messages"></intent-group>
              <div style="margin-top: 40px">
                <div>
                  <v-btn
                    :loading="saveloading"
                    block
                    :color="approveType == 'approve' ? 'green' : 'red'"
                    dark
                    @click="changeUserStatus"
                    >{{ approveType }}</v-btn
                  >
                </div>
                <div
                  @click="
                    approveModal = false
                    messages = [[]]
                  "
                >
                  <v-btn block flat color="grey">Cancel</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import IntentGroup from '@/components/view/intent/IntentGroup.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import Pagination from '@/components/elements/Pagination.vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
    IntentGroup,
    Pagination,
    Multiselect,
  },
  data() {
    return {
      sortBy: { sortBy: 'duedate', rowsPerPage: 10 },
      currentImage: '',
      showImage: '',
      input: {
        search: '',
        work_type: '',
        need_qc: '',
        need_production: '',
      },
      status: 'waiting',
      pageloading: false,
      total: 0,
      filter: {
        type: '',
        search: '',
      },
      type: [
        'ทั้งหมด',
        'งานบรรยาย',
        'งานรีวิว',
        'ซื้อสื่อ/ซื้อโฆษณา',
        'งานMC/พิธีกร',
        'งานคิวร่วมงาน',
        'งานไลฟ์สด',
      ],
      currentMessage: '',
      addmessage: false,

      length: 2,
      messages: [[]],
      page: 1,
      headers: [
        {
          text: '',
          value: 'picture',
          align: 'center',
          sortable: false,
        },
        {
          text: '',
          value: 'picture',
          align: 'center',
          sortable: false,
        },
        {
          text: 'ชื่อ',
          value: 'customer_name',
          align: 'center',
        },
        {
          text: 'ประเภทงาน',
          value: 'work_type',
          align: 'center',
        },
        {
          text: 'รายละเอียด',
          value: 'detail',
          align: 'center',
        },
        {
          text: 'วันที่นัด',
          align: 'center',
          value: 'duedate',
        },
        {
          text: 'วันที่ติดต่อ',
          align: 'center',
          value: 'timestamp',
        },
        {
          text: 'สถานที่',
          value: 'location',
          align: 'center',
        },
        {
          text: 'ชื่อบริษัท',
          value: 'companyname',
          align: 'center',
        },
        {
          text: 'เบอร์โทรศัพท์',
          value: 'phoneno',
          align: 'center',
        },
        {
          text: 'อีเมล์',
          value: 'email',
          align: 'center',
        },

        {
          text: 'นามบัตร',
          value: 'business_card',
          align: 'center',
        },
      ],
      users: [],
      approveModal: false,
      rejectModal: false,
      saveloading: false,
      currentUser: '',
      currentId: '',
      approveType: '',
      limit: 10,
      offset: 0,
      update: 0,
    }
  },
  computed: {
    moment() {
      return moment
    },
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    this.getData(this.status)
    var vm = this
    vm.$store.dispatch('loadCategory').then(function () {
      vm.$store.dispatch('loadProducts')
    })
    vm.$store.dispatch('loadCharges')

    vm.$store.dispatch('loadSetting')
  },
  methods: {
    clickShowImage(img) {
      this.showImage = true
      this.currentImg = img
    },
    onSearch() {
      this.getData(this.status)
    },
    onChangeStatusView() {
      this.users = []
      this.getData(this.status, 10, 0)
    },
    changeUserStatus() {
      var vm = this
      this.saveloading = true
      var body = {
        id: this.currentId,
        userid: this.currentUser,
        pageid: this.selectedBot.pageid,
        status: this.approveType, // approve กับ reject
        a_val: JSON.stringify(this.messages),
      }
      api.putceemeagainstatuscustomer(body, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          vm.$swal.fire({
            type: 'success',
            text: 'สำเร็จ',
          })
          vm.getData(this.status)
          this.approveModal = false
          this.update++
        }
      })
    },
    onChange(val, status) {
      this.getData(status, val.limit, val.offset)
    },
    getData(status, limit = 10, offset = 0) {
      this.pageloading = true
      api.getceemeagaincustomer(
        {
          pageid: this.selectedBot.pageid,
          status: status, // waiting(ยังไม่ approve), history(approveแล้ว กับ rejectแล้ว),
          limit: limit,
          offset: offset,
          search: this.input.search ? this.input.search : '', //customer_name
          work_type:
            this.input.work_type && this.input.work_type != 'ทั้งหมด' ? this.input.work_type : '',
          need_qc: this.input.need_qc ? this.input.need_qc : '', //boolean
          need_production: this.input.need_production ? this.input.need_production : '', //boolean
        },
        (err, response) => {
          if (response.responsecode == 200) {
            if (response.data) {
              this.users = response.data
              this.total = parseInt(this.users[0].total)
            } else {
              this.users = []
              this.total = 0
            }
            this.pageloading = false
          }
        }
      )
    },
    approveClick(id, userid) {
      var vm = this

      this.approveModal = true
      this.currentId = id
      this.currentUser = userid
      this.approveType = 'approve'
      this.messages = [
        [
          {
            text:
              'แอดมินรับเรื่องเรียบร้อยแล้วค่ะ กรุณารอสักครู่ ทีมงานจะติดต่อกลับไป หรือส่งเรทการ์ดให้โดยเร็วที่สุดค่ะ เร่งด่วนโทร 091-819-7925',
            type: 'text',
          },
        ],
      ]
    },
    rejectClick(id, userid) {
      this.approveModal = true
      this.currentId = id
      this.currentUser = userid
      this.approveType = 'reject'
      this.messages = [[{ text: 'ทีมงานจะติดต่อกลับไปภายหลังค่ะ', type: 'text' }]]
    },
  },
}
</script>

<style lang="scss">
.addceemeagain {
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 10px;
  border: 2px darkgrey dashed;
  color: darkgrey;
  cursor: pointer;
}
.addceemeagain:hover {
  color: grey;
  border: 2px grey dashed;
}
.moochip {
  color: white;
  font-size: 11px;
  font-weight: 400;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 6px;
}
// .my-awesome-table table {
//   table-layout: fixed !important;
// }
.my-awesome-table table th {
  text-align: center !important;
}
.my-awesome-table table td {
  word-break: break-word;
  text-align: center !important;
}
.newiconceeme {
  color: white;
  background-color: #ff5d5d;
  display: inline;
  font-size: 10px;
  padding-left: 4px;
  padding-right: 4px;
  font-weight: 500;
  border-radius: 10px;
  right: 0px;
  bottom: 0px;
  position: absolute;
  box-shadow: 2px 2px 3px -1px rgba(0, 0, 0, 0.75);
}
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/Ceemeagain.vue